import { Component, HostListener } from '@angular/core';
import { PostService } from 'src/app/services/repositories/post.service';
import { Subscription } from 'rxjs';
import { GroupService } from 'src/app/services/repositories/group.service';
import { IResponse } from 'src/app/interfaces/IResponse';
import { SocialMediaService } from 'src/app/services/repositories/social-media.service';
import { UiStateService } from 'src/app/services/utilities/ui-state.service';

@Component({
  selector: 'app-facebook-stats',
  templateUrl: './facebook-stats.component.html',
  styleUrls: ['./facebook-stats.component.scss']
})
export class FacebookStatsComponent {
  data: Array<{
    label: string;
    value: string;
    icon:string,
    unit:string,
    tooltip:string,
    tooltipPosition:string
  }> = [];
  private subs = new Subscription();
  socialMedias: any[] = [];
  constructor(protected postService: PostService,
    private groupService: GroupService,
    private socialMediaService:SocialMediaService,
    private uiStateService:UiStateService
    ){}
  subscriptions: Subscription[] = [];
  period={startDate:new Date() , endDate:new Date}
  isInsightsLoading:boolean=true
  facebookPageIds:any[]=[]
  facebookPageNames:any[]=[]
  updateStats(dateValue:any){
    // console.log("["+this.constructor.name+"] updating States",dateValue,this.period)
    dateValue.startDate = dateValue.pageStatsendDate? dateValue.pageStatsstartDate:dateValue.startDate
    dateValue.endDate = dateValue.pageStatsendDate ? dateValue.pageStatsendDate:dateValue.endDate
    if(dateValue.endDate>new Date()){
      dateValue.endDate = new Date()
    }    
    
    this.period = dateValue
    this.uiStateService.pageStatsupdateDateRange(dateValue)
    this.isInsightsLoading=true
    // console.log("facebookPageIds",this.facebookPageIds, this.period)
    if(this.facebookPageIds.length>0){
      this.socialMediaService.getPageStatesProgress(this.facebookPageIds,this.period).subscribe((res:any)=>{
        console.log(`[${this.constructor.name}] period ${JSON.stringify(this.period)}`)
        console.log(res.data)
        const resObj = res.data.results?.reduce((sums:any, obj:any) => {
          for (const key in obj) {
            if(key!="searchResults"){
              sums[key] = (sums[key] || 0) + (obj[key] || 0);
            }
            else{
              sums[key] = "--"
            }
          }
          return sums;
        }, {});
        
        console.log(resObj)
        for(let item of this.data){
          for(let key in item){
            if(key ==="label"){
              const prop = item[key].replace("insights.facebook.","")
              item.value = resObj[prop]
            }
          }
        }
         console.log("[",this.constructor.name,"] facebook stats", this.data,"period",this.period)
         
        this.isInsightsLoading=false
      })
    }
    // console.log("end of update States",dateValue,this.period)
  }
  AllGrouPages:any[]=[]
  ngOnInit(){
    const lsData = this.postService.getGroupScopesFromLocalStorage();
    
    this.data = [
      {"label": "insights.facebook.numberOfPublications", "value":'--', "icon":"grid","unit":"","tooltip":"tooltip.facebook.numberOfPublications","tooltipPosition":"tooltip-top"},
      {"label": "insights.facebook.pageViews", "value":'--', "icon":"eye","unit":"","tooltip":"tooltip.facebook.pageViews","tooltipPosition":"tooltip-top"},
      {"label": "insights.facebook.interactions", "value":'--', "icon":"click","unit":"","tooltip":"tooltip.facebook.interactions","tooltipPosition":"tooltip-top"},
      {"label": "insights.facebook.impressions", "value":'--', "icon":"image-view","unit":"","tooltip":"tooltip.facebook.impressions","tooltipPosition":"tooltip-top"},
      {"label": "insights.facebook.pageLikes", "value":'--', "icon":"heart","unit":"","tooltip":"tooltip.facebook.pageLikes","tooltipPosition":"tooltip-top"},
      {"label": "insights.facebook.reach", "value":'--', "icon":"user-star","unit":"","tooltip":"tooltip.facebook.reach","tooltipPosition":"tooltip-right"},
      {"label": "insights.facebook.reactions", "value":'--', "icon":"like","unit":"","tooltip":"tooltip.facebook.reactions","tooltipPosition":"tooltip-top"},
      {"label": "insights.facebook.comments", "value":'--', "icon":"chat","unit":"","tooltip":"tooltip.facebook.comments","tooltipPosition":"tooltip-top"},
      {"label": "insights.facebook.shares", "value":'--', "icon":"share","unit":"","tooltip":"tooltip.facebook.shares","tooltipPosition":"tooltip-top"},
      {"label": "insights.facebook.linkClicks", "value":'--', "icon":"link-click","unit":"","tooltip":"tooltip.facebook.linkClicks","tooltipPosition":"tooltip-top"},
      {"label": "insights.facebook.followers", "value":'--', "icon":"user","unit":"","tooltip":"tooltip.facebook.followers","tooltipPosition":"tooltip-right"},
      {"label": "insights.facebook.newFollowers", "value":'--', "icon":"user-plus","unit":"","tooltip":"tooltip.facebook.newFollowers","tooltipPosition":"tooltip-top"},
      {"label": "insights.facebook.Unfollows", "value":'--', "icon":"user-minus","unit":"","tooltip":"tooltip.facebook.Unfollows","tooltipPosition":"tooltip-top"},
      {"label": "insights.facebook.visits", "value":'--', "icon":"user-visible","unit":"","tooltip":"tooltip.facebook.visits","tooltipPosition":"tooltip-top"},
      {"label": "insights.facebook.totalPostsLikes", "value":'--', "icon":"heart-plus","unit":"","tooltip":"tooltip.facebook.totalPostsLikes","tooltipPosition":"tooltip-top"},
      // {"label": "insights.facebook.video3secViews", "value":'--', "icon":"","unit":"","tooltip":"----","tooltipPosition":"tooltip-top"},
      // {"label": "insights.facebook.video1minViews", "value":'--', "icon":"","unit":"","tooltip":"----","tooltipPosition":"tooltip-top"},
      // {"label": "insights.facebook.viewsDuration", "value":'--', "icon":"","unit":"min ","tooltip":"----","tooltipPosition":"tooltip-top"},
      // {"label": "insights.facebook.starRecieved ", "value":'--', "icon":"","unit":"","tooltip":"----","tooltipPosition":"tooltip-top"},
      // {"label": "insights.facebook.estimatedRevenue ", "value":'--', "icon":"","unit":"","tooltip":"----","tooltipPosition":"tooltip-top"},
      
    ];
    this.subscriptions.push(
      this.postService.currentGroups.subscribe((g: number[]) => {
        if (g.length == 0)
          g = this.postService.getGroupScopesFromLocalStorage();
        
        if (g.length > 0) {
          this.groupService.getGroupByIds(g).subscribe((res: IResponse) => {
            this.isInsightsLoading=true
            this.AllGrouPages =this.getRecursiveSocialMediaPages(res.data)
          
            this.facebookPageNames =this.AllGrouPages.filter((sm:any)=>sm.source=="facebook").map((lp:any)=> {return {id:lp.id,name:lp.name,url:lp.url}})||[];
            this.facebookPageIds = this.AllGrouPages.filter((sm:any)=>sm.source=="facebook").map((lp:any)=>lp.id)||[];
            if(this.facebookPageIds.length>0){
              this.subscriptions.push(
                this.socialMediaService.getPageStatesProgress(this.facebookPageIds,this.period).subscribe((res:any)=>{
                  this.period=res.data.period
                  const resObj = res.data.results?.reduce((sums:any, obj:any) => {
                    for (const key in obj) {
                      sums[key] = (sums[key] || 0) + (obj[key] || 0);
                    }
                    return sums;
                  }, {});
                  for(let item of this.data){
                    for(let key in item){
                      if(key ==="label"){
                        const prop = item[key].replace("insights.facebook.","")
                        item.value = resObj[prop]
                        // console.log("updating",prop, resObj[prop],item[key])
                      }
                    }
                  }
                  // console.log("facebook stats",resObj, this.data) 
                  this.isInsightsLoading=false
                })
              )
            }
            let page_actions_post_reactions_total = 0; 
            let commentCount = 0;
            let total_shares_on_page = 0;
            let clickCount = 0;
            let page_post_engagements = 0;
            let page_posts_impressions = 0;
            let number_of_publications = 0;
            let page_follows = 0
            let page_fan_adds = 0;
            let page_fan_removes = 0;
            this.socialMedias.forEach((item: any)=>{
              if(item.source == 'facebook' && item.analytics){
                item.analytics.forEach((element:any)=>{
                    if(element.name =='number_of_publications')
                      number_of_publications += this.gVal(element.value);
                    if(element.name =='page_actions_post_reactions_total'){
                      page_actions_post_reactions_total = this.gVal(Object.values(element.value).reduce((accumulator: any, currentValue: any) => {
                        return accumulator + currentValue;
                      }, 0));
                    }
                    if(element.name =='page_posts_impressions')
                      page_posts_impressions += this.gVal(element.value);
                    if(element.name =='page_post_engagements')
                      page_post_engagements += this.gVal(element.value);
                    if(element.name =='page_total_actions')
                      clickCount += this.gVal(element.value);
                    if(element.name =='page_fan_adds')
                      page_fan_adds += this.gVal(element.value)
                    if(element.name =='total_comments_on_page')
                      commentCount += this.gVal(element.value);
                    if(element.name =='page_fan_removes')
                      page_fan_removes += this.gVal(element.value)
                    if(element.name =='total_shares_on_page')
                      total_shares_on_page += this.gVal(element.value);
                    if(element.name =='page_follows')
                      page_follows += this.gVal(element.value);
                })
              }
            })
            this.data[0].value =this.facebookPageIds.length==0?"--": number_of_publications.toString();
            this.data[1].value =this.facebookPageIds.length==0?"--": page_posts_impressions.toString();
            this.data[2].value =this.facebookPageIds.length==0?"--": page_actions_post_reactions_total.toString();
            this.data[3].value =this.facebookPageIds.length==0?"--": commentCount.toString();
            this.data[4].value =this.facebookPageIds.length==0?"--": total_shares_on_page.toString();
            this.data[5].value =this.facebookPageIds.length==0?"--": page_post_engagements.toString();
            this.data[6].value =this.facebookPageIds.length==0?"--": page_follows.toString();
            this.data[7].value =this.facebookPageIds.length==0?"--": page_fan_adds.toString();
            this.data[8].value =this.facebookPageIds.length==0?"--": page_fan_removes.toString();
            this.data[9].value ="--"
            this.data[10].value ="--"
            this.data[11].value ="--"
            this.data[12].value ="--"
            this.data[13].value ="--"
            this.data[14].value ="--"
          });
        }
      })
    );
  }

  generalInsightsLabels:string[]=[
    'insights.facebook.numberOfPublications',
    'insights.facebook.pageViews',
    'insights.facebook.interactions',
    'insights.facebook.impressions',
    'insights.facebook.pageLikes',
  ]

  indicatorsInsightsLabels:string[]=[
    'insights.facebook.reach',
    'insights.facebook.reactions',
    'insights.facebook.comments',
    'insights.facebook.shares',
    'insights.facebook.linkClicks',
  ]

  audienceInsightsLabels:string[]=[
    'insights.facebook.followers',
    'insights.facebook.newFollowers',
    'insights.facebook.Unfollows',
    'insights.facebook.visits',
    'insights.facebook.totalPostsLikes',
  ]

  videoInsightsLabels:string[]=[
    'insights.facebook.videoViews',
    'insights.facebook.videoDuration',
  ]

  adsInsightsLabels:string[]=[
    'insights.facebook.customButtonClicks',
    'insights.facebook.visitDuration',
  ]
  GetGeneralData(){
    return this.data.filter((item:any)=>this.generalInsightsLabels.includes(item.label))
  }

  GetIndicatorsData(){
    return this.data.filter((item:any)=>this.indicatorsInsightsLabels.includes(item.label))
  }

  GetAudienceData(){
    return this.data.filter((item:any)=>this.audienceInsightsLabels.includes(item.label))
  }

  GetVideoData(){
    return this.data.filter((item:any)=>this.videoInsightsLabels.includes(item.label))
  } 

  GetAdsData(){
    return this.data.filter((item:any)=>this.adsInsightsLabels.includes(item.label))
  }
  getRecursiveSocialMediaPages(groups: any[]): any[] {
    groups = !Array.isArray(groups) ? [groups] : groups;
    let socialMediaPages: any[] = [];
    groups.forEach((group: any) => {
      // Add the group's social media pages if any
      if (group.socialMedia && group.socialMedia.length > 0) {
        socialMediaPages = [...socialMediaPages, ...group.socialMedia];
      }
      // Recursively add social media pages from children
      if (group.children && group.children.length > 0) {
        for (let child of group.children) {
          socialMediaPages = [
            ...socialMediaPages,
            ...this.getRecursiveSocialMediaPages(child),
          ];
        }
      }
    });
    //removing any duplicates
    const pagesArrayString: string[] = socialMediaPages.map((sm: any) =>
      JSON.stringify(sm)
    );
    const uniquePagesArrayString = [...new Set(pagesArrayString)];
    this.socialMedias = uniquePagesArrayString.map((sm: any) =>
      JSON.parse(sm)
    );
    return uniquePagesArrayString.map((sm: any) => JSON.parse(sm));
  }

  gVal(data: any){
    return data && Number(data)? Number(data): 0
  }

  // delete this part 
  isPlanned: boolean = true; 
  isPost: boolean = true; 
  isDraft: boolean = true; 
  windowWidth: number = window.innerWidth;
  isLargeView: boolean = false;
  isMediumView: boolean = false;
  isSmallView: boolean = false;
  isVerySmallView: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.windowWidth = window.innerWidth;

    if (1232 < this.windowWidth && this.windowWidth < 1375) {
      // Medium view
      this.isLargeView = false;
      this.isMediumView = true;
      this.isSmallView = false;
      this.isVerySmallView = false;
    } else if (1375 <= this.windowWidth && this.windowWidth < 1515) {
      // Large view
      this.isLargeView = true;
      this.isMediumView = false;
      this.isSmallView = false;
      this.isVerySmallView = false;
    } else if (this.windowWidth >= 1515) {
      // Extra large view
      this.isLargeView = false;
      this.isMediumView = false;
      this.isSmallView = false;
      this.isVerySmallView = false;
    } else if (this.windowWidth >= 1100 && this.windowWidth < 1232) {
      // Small view (windowWidth <= 1232)
      this.isLargeView = false;
      this.isMediumView = false;
      this.isSmallView = true;
      this.isVerySmallView = false;
    } else {
      this.isLargeView = false;
      this.isMediumView = false;
      this.isSmallView = false;
      this.isVerySmallView = true;
    }
  }

  togglePost() {
    this.isPost = !this.isPost;
  }
  togglePlanned() {
    this.isPlanned = !this.isPlanned;
  }
  // end delete
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

}
